import { render, staticRenderFns } from "./AddOrganisation.vue?vue&type=template&id=5adb0a51&"
import script from "./AddOrganisation.vue?vue&type=script&lang=ts&"
export * from "./AddOrganisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports